import { cartPerformance } from '@lib/performance';
import { fetchConfig, getSectionsToRender } from '@lib/section-utils';
import { CartDrawer } from '@lib/cart-drawer';
import { PUB_SUB_EVENTS, publish, shippingconversion, openDrawer, closeDrawer, overflowAdd, overflowRemove } from '@lib/pubsub';
export class ProductForm extends HTMLElement {
	constructor() {
		super();
		this.form = this.querySelector('form');
		var carddetailsHover = false;
	
		if (this.form) {
		  this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
		}
	
		this.cart = null;
		// Load cart drawer safely

		if (customElements.get('cart-drawer')) {
			this.cart = document.querySelector('cart-drawer');
		
			
		} else {
			customElements.whenDefined('cart-drawer').then(() => {
				this.cart = document.querySelector('cart-drawer');
				
			});
		}
		this.submitButton = this.querySelector('[type="submit"]');
		this.submitButtonText = this.submitButton?.querySelector('[data-button-text]');

		this.hideErrors = this.dataset.hideErrors === 'true';
		if (this.form) this.initCfrBundle(); // IOI: Fast Bundle Multi-BAP picker (snippets/cfr-fb-bundle.liquid)
	}
	
	/** IOI Sep 2026: Fast Bundle (Separate line items) picker, container rendered by snippets/cfr-fb-bundle.liquid.
	 *  Zero config: waits for Fast Bundle's widget, reads the component product links it renders, fetches
	 *  /products/<handle>?view=cfr-json (templates/product.cfr-json.liquid) and builds the theme's own size tiles.
	 *  Each component gets a hidden input[name=id].product-variant-id[data-product-handle] so onSubmitHandler's
	 *  bundle branch adds them as separate lines (with the Stoq selling plan on pre-order sizes).
	 *  Falls back to Fast Bundle's own widget if the components cannot be read. Runs from the constructor so it
	 *  also works inside the quick-view drawer. */
	initCfrBundle() {
		const root = this.form.querySelector('[data-cfr-v7]');
		if (!root || root.dataset.cfrReady) return;
		root.dataset.cfrReady = '1';
		const form = this.form;
		const uid = root.dataset.uid || String(Date.now());
		const compRank = (t) => (/\bTop\b/i.test(t) ? 0 : /(Bottom|Skirt|Short|Pant)/i.test(t) ? 1 : 2);
		const compLabel = (t) => {
			const last = (t.split(' - ').pop() || t).trim();
			return last + ' Size';
		};
		const fallback = (why) => {
			root.dataset.cfrState = 'fallback';
			root.dataset.cfrWhy = why || '';
			document.body.classList.add('cfr-v7-fallback');
			// no Fast Bundle widget at all (e.g. quick view): never sell the placeholder variant, send them to the page
			if (why === 'no-widget' && root.dataset.productUrl && this.submitButton) {
				this.submitButton.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); window.location.href = root.dataset.productUrl; }, true);
			}
		};

		// 1. wait for Fast Bundle to render the component list (links to /products/<handle>)
		const readHandles = () => {
			const scope = root.closest('product-information');
			let links = scope ? scope.querySelectorAll('[id^="rbr-container-element"] a[href*="/products/"]') : [];
			if (!links.length) links = document.querySelectorAll('[id^="rbr-container-element"] a[href*="/products/"]');
			const out = [];
			links.forEach((a) => {
				const m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/i);
				if (m && out.indexOf(m[1]) < 0) out.push(m[1]);
			});
			return out;
		};
		const waitForHandles = () => new Promise((resolve) => {
			const started = Date.now();
			const tick = () => {
				const h = readHandles();
				if (h.length) return resolve(h);
				const hasWidget = !!document.querySelector('[id^="rbr-container-element"]');
				if (Date.now() - started > (hasWidget ? 12000 : 6000)) return resolve(hasWidget ? [] : null);
				setTimeout(tick, 250);
			};
			tick();
		});

		// 2. component data from the theme's JSON view
		const fetchComp = (handle) => fetch('/products/' + handle + '?view=cfr-json', { credentials: 'same-origin' })
			.then((r) => r.text())
			.then((t) => JSON.parse(t.trim()));

		// 3. build the tiles (same markup as the theme's variant picker)
		const render = (comps) => {
			comps.sort((a, b) => compRank(a.title) - compRank(b.title));
			const tile = root.dataset.tileSize || 'small';
			const style = root.dataset.tileStyle || 'box';
			const labelSize = root.dataset.labelSize || 'small';
			const pb = form.querySelector('.product-buttons');
			const frag = document.createDocumentFragment();
			let anyPreDefault = false;
			comps.forEach((cp) => {
				if (!cp.variants || !cp.variants.length) return;
				const def = cp.variants.find((v) => v.available) || cp.variants[0];
				const fs = document.createElement('fieldset');
				fs.className = 'variant-option variant-option-variants cfr-v7-option';
				fs.dataset.cfrComp = cp.handle;
				fs.dataset.cfrTitle = cp.title;
				const tb = document.createElement('div');
				tb.className = 'variant-option-titlebox';
				const p = document.createElement('p');
				p.className = 'product-infobox-label body-font text-' + labelSize;
				p.textContent = compLabel(cp.title);
				tb.appendChild(p);
				fs.appendChild(tb);
				const box = document.createElement('div');
				box.className = 'size-variants-' + style;
				const ul = document.createElement('ul');
				ul.className = 'size-variants size-variants-' + tile + ' size-variants-' + style;
				cp.variants.forEach((v) => {
					const li = document.createElement('li');
					li.className = 'size-variant' + (v.available ? '' : ' option-disabled cfr-oos') + (v.preorder ? ' cfr-pre option-preorder' : '');
					li.dataset.cfrSize = v.title;
					const inp = document.createElement('input');
					inp.type = 'radio';
					inp.name = 'cfr7-' + uid + '-' + cp.handle;
					inp.id = 'cfr7-' + uid + '-' + v.id;
					inp.value = String(v.id);
					inp.dataset.optionAvailable = String(!!v.available);
					inp.dataset.optionPreorder = String(!!v.preorder);
					inp.dataset.sellingPlan = v.selling_plan ? String(v.selling_plan) : '';
					inp.dataset.price = String(v.price);
					inp.dataset.qty = String(v.qty == null ? '' : v.qty);
					inp.dataset.managed = String(!!v.managed);
					if (!v.available) inp.disabled = true;
					if (v.id === def.id) inp.checked = true;
					const lab = document.createElement('label');
					lab.setAttribute('for', inp.id);
					lab.textContent = v.title;
					li.appendChild(inp);
					li.appendChild(lab);
					ul.appendChild(li);
				});
				box.appendChild(ul);
				fs.appendChild(box);
				const line = document.createElement('input');
				line.type = 'hidden';
				line.name = 'id';
				line.className = 'product-variant-id cfr-v7-line';
				line.dataset.productHandle = cp.handle;
				line.value = String(def.id);
				if (!def.available) line.disabled = true;
				// the line input must live inside the form (the tiles may be moved into the variant picker block)
				if (pb) form.insertBefore(line, pb); else form.appendChild(line);
				frag.appendChild(fs);
				if (def.preorder) anyPreDefault = true;
			});
			const note = document.createElement('p');
			note.className = 'cfr-v7-note preorder-note body-font text-xsmall';
			note.textContent = 'Pre-order · Shipping: ' + (root.dataset.ship || '');
			note.hidden = !anyPreDefault;
			frag.appendChild(note);
			root.appendChild(frag);
			// Sit where the theme's own variant picker would be (it renders empty for the FB placeholder variant),
			// so the tiles land above Size Chart / quantity exactly like a normal product. Falls back to in-form.
			const scope = root.closest('product-information');
			const vpBox = scope && scope.querySelector('[id^="product-infobox-variant_picker"]');
			if (vpBox) { vpBox.appendChild(root); root.classList.add('cfr-v7--in-picker'); }
			else root.classList.add('cfr-v7--in-form');
		};

		// 4. keep the hidden line inputs + button in sync with the checked tiles
		const bind = () => {
			form.classList.add('cfr-v7-form');
			// Fast Bundle hangs its own click handler on the theme button; keep the theme submit flow.
			form.addEventListener('click', (e) => {
				const b = e.target.closest && e.target.closest('button[type="submit"]');
				if (b && form.contains(b)) e.stopPropagation();
			}, true);
			// Fast Bundle inline-hides every li.size-variant in the form (it expects to own variant UI); undo that for our tiles.
			// ...and it force-hides the theme quantity selector; keep both visible.
			const unhide = () => [form, root].forEach((scope) => scope.querySelectorAll('li.size-variant[style], .quantity-control[style], quantity-selector[style]').forEach((el) => {
				if (/display\s*:\s*none/i.test(el.getAttribute('style') || '')) el.style.removeProperty('display');
			}));
			unhide();
			const mo = new MutationObserver(unhide);
			mo.observe(form, { attributes: true, attributeFilter: ['style'], subtree: true });
			if (!form.contains(root)) mo.observe(root, { attributes: true, attributeFilter: ['style'], subtree: true });
			const note = root.querySelector('.cfr-v7-note');
			const setText = (txt) => {
				if (!this.submitButtonText) return;
				let node = null;
				this.submitButtonText.childNodes.forEach((n) => { if (n.nodeType === 3 && n.nodeValue.trim()) node = n; });
				if (node) node.nodeValue = ' ' + txt + ' ';
				else this.submitButtonText.appendChild(document.createTextNode(txt));
			};
			// stock badge (theme's product-inventory) follows the selected components: pre-order > lowest stock
			const inv = (root.closest('product-information') || document).querySelector('product-inventory');
			const threshold = parseInt(root.dataset.invThreshold, 10) || 5;
			const setBadge = (cls, txt) => {
				if (!inv) return;
				const st = inv.querySelector('.product-inventory-status');
				const tx = inv.querySelector('.inventory-text');
				if (st) st.className = 'product-inventory-status ' + cls;
				if (tx) tx.textContent = txt;
			};
			const sync = () => {
				let anyPre = false;
				let allOk = true;
				let minQty = Infinity;
				root.querySelectorAll('fieldset[data-cfr-comp]').forEach((fs) => {
					const line = form.querySelector('input.cfr-v7-line[data-product-handle="' + fs.dataset.cfrComp + '"]');
					if (!line) return;
					const r = fs.querySelector('input[type="radio"]:checked');
					if (!r || r.disabled) {
						allOk = false;
						line.disabled = true;
						return;
					}
					line.disabled = false;
					line.value = r.value;
					if (r.dataset.managed === 'true') minQty = Math.min(minQty, parseInt(r.dataset.qty, 10) || 0);
					const sp = r.dataset.sellingPlan;
					if (r.dataset.optionPreorder === 'true' && sp) {
						anyPre = true;
						line.dataset.sellingPlan = sp;
						line.dataset.lineProps = JSON.stringify({ Shipping: root.dataset.ship || '' });
					} else {
						delete line.dataset.sellingPlan;
						delete line.dataset.lineProps;
					}
				});
				if (this.submitButton) {
					this.submitButton.disabled = !allOk;
					this.submitButton.setAttribute('data-preorder', anyPre ? 'true' : 'false');
					setText(anyPre ? (root.dataset.preText || 'Pre-order') : (root.dataset.addText || 'Add to cart'));
				}
				if (note) note.hidden = !anyPre;
				if (!allOk) setBadge('no-stock', root.dataset.txtOut || 'Out of stock');
				else if (anyPre) setBadge('pre-order', root.dataset.txtPre || 'Pre-order');
				else if (minQty !== Infinity && minQty <= 0) setBadge('no-stock', root.dataset.txtOut || 'Out of stock');
				else if (minQty !== Infinity && minQty <= threshold) setBadge('low-stock', root.dataset.txtLow || 'Low stock');
				else setBadge('in-stock', root.dataset.txtIn || 'In stock');
			};
			root.addEventListener('change', sync);
			sync();
			root.dataset.cfrState = 'ready';
		};

		waitForHandles().then((handles) => {
			if (handles === null) return fallback('no-widget');
			if (!handles.length) return fallback('no-links');
			return Promise.all(handles.map(fetchComp)).then((comps) => {
				comps = comps.filter((c) => c && c.variants && c.variants.length);
				if (!comps.length) return fallback('no-data');
				render(comps);
				bind();
			});
		}).catch((e) => { console.warn('[cfr-fb-bundle]', e); fallback('error'); });
	}

	onSubmitHandler(evt) {
		evt.preventDefault();
	  
		// IOI Sep 2026: bundle lines follow the theme quantity selector (1 if absent)
		const bundleQtyField = this.form.querySelector('input[name="quantity"]');
		const bundleQty = Math.max(1, parseInt(bundleQtyField && bundleQtyField.value, 10) || 1);
		const bundleVariants = [...this.form.querySelectorAll('input[name="id"].product-variant-id[data-product-handle]')].filter((input) => !input.disabled)
		  .map(input => {
				const item = { id: input.value, quantity: bundleQty };
				if (input.dataset.isPreorder === 'true' && input.dataset.preorderName) {
					item.properties = {
					[input.dataset.preorderName]: input.dataset.preorderValue || ''
					};
				}
				// IOI Sep 2026: Fast Bundle Multi-BAP lines (snippets/cfr-fb-bundle.liquid) carry the component's Stoq selling plan + Shipping property
				if (input.dataset.sellingPlan) item.selling_plan = input.dataset.sellingPlan;
				if (input.dataset.lineProps) { try { item.properties = Object.assign(item.properties || {}, JSON.parse(input.dataset.lineProps)); } catch (e) {} }
				return item;
		  });
	  
		const isBundle = bundleVariants.length >= 1;
	  
		/** ----------- NORMAL UI + BUTTON PREP ----------- **/
		if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
	  
		this.handleErrorMessage();
		const getPrevFocusElement = document.querySelector('.prev-focuse-element');
		if(getPrevFocusElement) getPrevFocusElement.classList.remove('prev-focuse-element');
	  
		this.submitButton.classList.add('prev-focuse-element');
		this.submitButton.setAttribute('aria-disabled', true);
	  
		if (this.submitButton.querySelector('[data-product-button]')) {
		  this.submitButton.querySelector('[data-product-button]').classList.add('hidden');
		  this.submitButton.insertAdjacentHTML('beforeend', `
			<span class="btn-loader" data-btn-loader>
			  <span class="svg-inside">
				<svg fill="currentColor" viewBox="0 0 24 24" class="icon-btn-loader">
				  <circle cx="4" cy="12" r="3">
					<animate id="spinner_jObz" begin="0;spinner_vwSQ.end-0.25s" attributeName="r" dur="0.75s" values="3;.2;3"/>
				  </circle>
				  <circle cx="12" cy="12" r="3">
					<animate begin="spinner_jObz.end-0.6s" attributeName="r" dur="0.75s" values="3;.2;3"/>
				  </circle>
				  <circle cx="20" cy="12" r="3">
					<animate id="spinner_vwSQ" begin="spinner_jObz.end-0.45s" attributeName="r" dur="0.75s" values="3;.2;3"/>
				  </circle>
				</svg>
			  </span>
			</span>
		  `);
		}
	  
		/** ----------- SEND AJAX ----------- **/
		const config = fetchConfig('javascript');
	  
		if (isBundle) {
		  config.headers['Content-Type'] = 'application/json';
		  config.body = JSON.stringify({
			items: bundleVariants,
			sections_url: window.location.pathname,
			sections: this.cart ? this.cart.getSectionsToRender().map(section => section.id) : undefined
		  });
		} else {
		  config.headers['X-Requested-With'] = 'XMLHttpRequest';
		  delete config.headers['Content-Type'];
	  
		  this.formData = new FormData(this.form);
	  
		  if (this.cart) {
			this.formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
			this.formData.append('sections_url', window.location.pathname);
			this.cart.setActiveElement(document.activeElement);
		  }
	  
		  config.body = this.formData;
		}
		
		fetch(`${Theme.routes.cart_add_url}`, config)
		  .then(response => response.json())
		  .then(response => {
	  
			/** ----------- ERROR HANDLING (same for both) ----------- **/
			if (response.status || response.errors) {
			  this.error = true;
			  publish(PUB_SUB_EVENTS.cartError, {
				source: 'product-form',
				productVariantId: isBundle ? null : this.formData.get('id') ? parseInt(this.formData.get('id')) : null,
				errors: response.errors || response.description,
				message: response.message,
			  });
			  if(response.description){
				this.handleErrorMessage(response.description);
			  }else{
				this.handleErrorMessage(response.errors);
			  }

			  return;
			}
	  
			/** ----------- SUCCESS FLOW ----------- **/
			publish(PUB_SUB_EVENTS.cartUpdate, {
			  source: 'product-form',
			  productVariantId: isBundle ? null : this.formData.get('id'),
			  cartData: response,
			});
	  
			if (this.cart && this.cart.classList.contains('is-empty')) {
			  this.cart.classList.remove('is-empty');
			}
	  
			setTimeout(() => {
			  openDrawer('cart');
			  overflowAdd();
			}, 100);
	  
			shippingconversion();
			this.cart?.renderContents(response);
		  })
		  .catch((e) => console.error(e))
		  .finally(() => {
	  
			this.submitButton.removeAttribute('aria-disabled');
			
			const loader = this.submitButton.querySelector('[data-btn-loader]');
			if (loader) loader.remove();
	  
			if (this.submitButton.querySelector('[data-product-button]')) {
			  this.submitButton.querySelector('[data-product-button]').classList.remove('hidden');
			}
		  });
	  }
	  
	handleErrorMessage(errorMessage = false, carddetailsHover) {
		if (this.hideErrors) return;
		this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-error-wrapper]');
		if (!this.errorMessageWrapper) return;
		this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');
		this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
		this.errorMessageWrapper.classList.toggle('hidden', !errorMessage);

		if (errorMessage) {
			// Check if errorMessage is an object
			if (typeof errorMessage === 'object' && errorMessage !== null) {
				// Clear existing content
				this.errorMessage.innerHTML = '';
				// Add each error as a span element
				Object.values(errorMessage).forEach((error, index) => {
					if (error) {
						const errorSpan = document.createElement('span');
						errorSpan.textContent = `- ${error}`;
						this.errorMessage.appendChild(errorSpan);
					}
				});
			} else {
				// Display as regular text content
				this.errorMessage.textContent = errorMessage;
			}
			  setTimeout(() => {
					this.errorMessageWrapper.classList.add('hidden');
					
					if(carddetailsHover){
						this.submitButton.closest('[data-product-card]').classList.add('carddetails-onhover');
						//this.submitButton.closest('[data-product-card]').classList.remove('carddetails-always');
					}
				}, 4000);
		}
	}
	toggleSubmitButton(disable = true, text) {
		if (disable) {
			this.submitButton.setAttribute('disabled', 'disabled');
			if (text) this.submitButtonText.textContent = text;
		} else {
			this.submitButton.removeAttribute('disabled');
			const isPreorder = this.submitButton.getAttribute('data-preorder') === 'true';
			this.submitButtonText.textContent = isPreorder
				? window.variantStrings.preOrder
				: window.variantStrings.addToCart;
		}
	}
	get variantIdInput() {
		return this.form.querySelector('[name=id]');
	}

}
if (!customElements.get('product-form')) {
	customElements.define('product-form', ProductForm);
}